'use client';
import Image from 'next/image';

import { decode } from 'html-entities';
import { DotBlockEditor } from '../shared/decodeTextBlock';

const Heading = ({ children }) => <h2 className="text-5xl text-white">{children}</h2>;

const Paragraph = ({ children }) => <p className="py-6 text-base text-slate-400">{children}</p>;

const BulletList = ({ children }) => <ul className="flex flex-col gap-4 text-base">{children}</ul>;

const ListItem = (props) => {
    const {
        node: { content = [] }
    } = props;
    return (
        <li className="flex items-center gap-2">
            <Image
                src={'/assets/icons/check.svg'}
                width={16}
                height={16}
                priority
                alt="check icon"
                className="size-6 min-h-6 min-w-6 p-1"
                unoptimized
            />
            <DotBlockEditor
                blocks={{
                    type: 'doc',
                    content
                }}
                className="prose prose-p:text-slate-400"
                customRenderers={{
                    text: Text
                }}
            />
        </li>
    );
};

const Text = (props) => {
    const {
        node: { text, marks },
        children
    } = props;

    if (marks?.length) {
        let link = marks.find((mark) => mark.type === 'link');

        const linkAttrs = link
            ? {
                  className: `${link.attrs?.class ?? ''} text-fuschia-600 underline`.trim(),
                  href: link.attrs?.href,
                  target: link.attrs?.target,
                  rel: link.attrs?.rel
              }
            : {};

        return link ? <a {...linkAttrs}>{decode(text)}</a> : children;
    } else return decode(text);
};

function ErrorPage({ errorDescription, errorMessage }) {
    return (
        <main className="flex w-full flex-col justify-center gap-5 bg-blue-700 px-5 py-3 md:flex-row-reverse md:px-16 md:py-10 lg:px-28 lg:py-32">
            <div className="order-2 w-full max-w-screen-sm sm:min-h-[390px] md:order-1 md:w-2/4">
                <Image
                    src="/assets/error/not-found.svg"
                    alt="dotCMS Not Found Image"
                    width={400}
                    height={390}
                    priority
                    unoptimized
                    className="w-full object-contain"
                />
            </div>
            <div className="order-1 flex flex-col gap-6 md:order-2 md:w-[70ch]">
                <h1 className="text-base font-semibold capitalize text-blue-500">{errorMessage}</h1>
                <DotBlockEditor
                    blocks={errorDescription}
                    customRenderers={{
                        heading: Heading,
                        paragraph: Paragraph,
                        bulletList: BulletList,
                        listItem: ListItem,
                        text: Text
                    }}
                />
            </div>
        </main>
    );
}

export default ErrorPage;
